import { Model } from '@/app/shared/models/model';
import {
  PreviousCampaign,
  CampaignStatus,
  ContractStatus,
  ReturnCodeType,
  PaymentMethod,
} from '@/app/shared/enums';
import {
  CampaignFrequency,
  CampaignRules,
  InstallmentCampaign,
} from '@/app/shared/models';

export class CampaignModel extends Model {
  public Name!: string;
  public TenantId!: string;
  public PreviousCampaign!: PreviousCampaign;
  public PaymentMethod!: PaymentMethod;
  public Status!: CampaignStatus;
  public ContractStatus!: ContractStatus;
  public ReturnCodeType!: ReturnCodeType;
  public InstallmentNumber!: number;
  public NumberDefaulterInstallments!: number;
  public AttemptNumber!: number;
  public StartDate!: string;
  public ExpiryDays!: number;
  public Active!: boolean;
  public CampaignFrequencies!: CampaignFrequency[];
  public CampaignRulers!: CampaignRules[];
  public StartDateCustom?: string;
  public CampaignId?: string;
  public CommunicationId?: string;
  public NotifyQuery?: string[];
  public NotifyId?: string;
  public InstallmentCampaigns?: InstallmentCampaign[];
}
